import { render, staticRenderFns } from "./LicencesLogs.vue?vue&type=template&id=14ababae"
import script from "./LicencesLogs.vue?vue&type=script&lang=js"
export * from "./LicencesLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports